/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { lazy } from 'react';
import styled from 'styled-components';

import { WidgetLazyLoadWrapper } from '../common/utilities/widgetLazyLoadWrapper';
import { AnimatedLoadingPlaceholder } from '../common/animatedLoadingPlaceholder/animatedLoadingPlaceholder';

const SparkWidget = lazy(() => import('./sparkWidget.jsx'));

export const SparkWidgetLazy = () => {
    return (
        <WidgetLazyLoadWrapper suspenseFallbackLoadingUI={<SparkWidgetLazyLoadingUI />}>
            <SparkWidget />
        </WidgetLazyLoadWrapper>
    );
};

const SparkWidgetLazyLoadingUI = () => {
    return (
        <Container>
            <AnimatedLoadingPlaceholder height='100%' radius={3} />
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    height: 150px;
`;